<template>
  <div 
    v-if="visible" 
    class="odds-filter-dropdown" 
    @click.stop
    @mouseenter="$emit('mouseenter')"
    @mouseleave="$emit('mouseleave')"
  >
    <div class="odds-checkbox-group">
      <!-- 亚盘 -->
      <div class="odds-checkbox-item" @click="toggleOdds('asian')">
        <div class="odds-checkbox" :class="{ checked: selectedOdds.includes('asian') }">
          <svg v-if="selectedOdds.includes('asian')" class="check-icon" viewBox="0 0 16 16" fill="none">
            <path d="M3 8L6.5 11.5L13 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span class="odds-label">亚</span>
      </div>
      
      <!-- 大小球 -->
      <div class="odds-checkbox-item" @click="toggleOdds('overUnder')">
        <div class="odds-checkbox" :class="{ checked: selectedOdds.includes('overUnder') }">
          <svg v-if="selectedOdds.includes('overUnder')" class="check-icon" viewBox="0 0 16 16" fill="none">
            <path d="M3 8L6.5 11.5L13 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span class="odds-label">大</span>
      </div>
      
      <!-- 欧赔 -->
      <div class="odds-checkbox-item" @click="toggleOdds('european')">
        <div class="odds-checkbox" :class="{ checked: selectedOdds.includes('european') }">
          <svg v-if="selectedOdds.includes('european')" class="check-icon" viewBox="0 0 16 16" fill="none">
            <path d="M3 8L6.5 11.5L13 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span class="odds-label">欧</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  initialSelected: {
    type: Array,
    default: () => ['asian', 'overUnder', 'european']
  }
})

const emit = defineEmits(['update:visible', 'odds-filter-change', 'mouseenter', 'mouseleave'])

// 选中的指数类型
const selectedOdds = ref([...props.initialSelected])

/**
 * 切换指数类型
 */
const toggleOdds = (value) => {
  const index = selectedOdds.value.indexOf(value)
  if (index > -1) {
    // 至少保留一个选项
    if (selectedOdds.value.length > 1) {
      selectedOdds.value.splice(index, 1)
    }
  } else {
    selectedOdds.value.push(value)
  }
  emitFilterChange()
}

/**
 * 发送筛选变更事件
 */
const emitFilterChange = () => {
  emit('odds-filter-change', [...selectedOdds.value])
  // 保存到 localStorage
  saveFilter()
}

/**
 * 保存筛选设置到 localStorage
 */
const saveFilter = () => {
  try {
    localStorage.setItem('football-odds-filter', JSON.stringify(selectedOdds.value))
  } catch (error) {
    console.error('保存指数筛选设置失败:', error)
  }
}

/**
 * 从 localStorage 加载筛选设置
 */
const loadFilter = () => {
  try {
    const saved = localStorage.getItem('football-odds-filter')
    if (saved) {
      const parsedFilter = JSON.parse(saved)
      if (Array.isArray(parsedFilter) && parsedFilter.length > 0) {
        selectedOdds.value = parsedFilter
        // 加载后立即通知父组件
        emitFilterChange()
      }
    }
  } catch (error) {
    console.error('加载指数筛选设置失败:', error)
  }
}

/**
 * 初始化筛选设置
 */
const initFilter = () => {
  // 优先从 localStorage 加载
  loadFilter()
}

// 初始化
initFilter()

// 监听 initialSelected 变化
watch(
  () => props.initialSelected,
  (newSelected) => {
    if (newSelected && newSelected.length > 0) {
      selectedOdds.value = [...newSelected]
    }
  },
  { deep: true }
)
</script>

<style scoped lang="scss">
.odds-filter-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: $scoreFootball-white;
  border-radius: 10px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  padding: 12px 16px;
  
  // 添加小三角箭头（可选）
  &::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid $scoreFootball-white;
  }

  .odds-checkbox-group {
    display: flex;
    align-items: center;
    gap: 20px;

    .odds-checkbox-item {
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      user-select: none;
      transition: all 0.2s ease;

      &:hover {
        .odds-checkbox {
          border-color: $scoreFootball-success;
        }
        
        .odds-label {
          color: $scoreFootball-success;
        }
      }

      .odds-checkbox {
        width: 16px;
        height: 16px;
        border: 2px solid #d9d9d9;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        background: $scoreFootball-white;
        flex-shrink: 0;

        &.checked {
          background: $scoreFootball-success;
          border-color: $scoreFootball-success;

          .check-icon {
            width: 9px;
            height: 9px;
            color: $scoreFootball-white;
          }
        }
      }

      .odds-label {
        font-size: 12px;
        color: #666;
        font-weight: 500;
        transition: color 0.2s ease;
        white-space: nowrap;
      }
    }
  }
}
</style>
